import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 47 — Closing punch: "Once we sit there… we don't get replaced."
 */

export default function Scene47_DontGetReplaced() {
  return (
    <SceneShell variant="gold" align="center" data-testid="scene-dont-get-replaced">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(255,232,168,0.30) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.50) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(255,232,168,0.30) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Concentric rings */}
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="absolute top-1/2 left-1/2 rounded-full border pointer-events-none"
          style={{
            width: 260,
            height: 260,
            borderColor: "rgba(0,0,0,0.30)",
            translate: "-50% -50%",
          }}
          animate={{ scale: [1, 4], opacity: [0.45, 0] }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeOut",
            delay: 1.0 + i * 1.4,
          }}
        />
      ))}

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.h2
          initial={{ opacity: 0, y: 32, filter: "blur(12px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.4, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display leading-[0.95]"
          style={{
            fontSize: "clamp(72px, 11vw, 180px)",
            color: "#0d0d0f",
            textShadow: "0 8px 60px rgba(0,0,0,0.32)",
            fontWeight: 900,
          }}
          data-testid="dont-get-replaced-headline"
        >
          We become
          <br />
          irreplaceable.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 2.6 }}
          className="mt-12 inline-flex items-center gap-3 rounded-full px-7 py-3"
          style={{
            background: "rgba(0,0,0,0.82)",
            color: "rgba(255,232,168,0.95)",
          }}
        >
          <Lock className="w-4 h-4" style={{ color: "#e9a820" }} />
          <span
            className="text-sm tracking-[0.28em] uppercase"
            style={{ fontWeight: 700 }}
          >
            Locked in
          </span>
        </motion.div>
      </div>
    </SceneShell>
  );
}
